module.exports = __webpack_public_path__ + "static/pic01-206e92b104963834da022abf080afc16.jpg";